import React from 'react';

import { ComponentMapping, type IIconProps, type IconName } from './Icon.types';

export const Icon = React.memo((props: IIconProps) => {
  const { sx, ...other } = props;
  const fullSX = {
    color: props.color,
    ...sx
  };

  const Component = ComponentMapping[props.name];

  if (!Component) {
    return <></>;
  }

  return <Component sx={fullSX} {...other} />;
});

// Takes in a name or an arbitrary node. Renders an icon with name='name' if the
// argument is a string, renders the node if passed in a node
export const useIcon = (iconOrName: IconName | React.ReactNode) => {
  if (typeof iconOrName === 'string' && iconOrName in ComponentMapping) {
    return <Icon name={iconOrName as IconName} />;
  }

  return iconOrName;
};
